import { Link } from "react-router-dom";
import { boardThemes } from "@/utils/site";

export interface TopicCardData {
  id: string;
  title: string;
  excerpt: string;
  boardName: string;
  author: string;
  authorTag: string;
  createdAt: string;
  replies: number;
  views: number;
  likes: number;
  tags: string[];
  cover: string;
  accent: string;
}

export default function TopicCard({ topic }: { topic: TopicCardData }) {
  const theme = boardThemes[topic.accent] ?? boardThemes.primary;

  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topic/${topic.id}`} className="relative block h-44 w-full overflow-hidden">
        <img
          src={topic.cover}
          alt={`${topic.title} 话题配图`}
          title={`${topic.title} - 瓜田社区讨论帖`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span
          className={`absolute left-3 top-3 flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${theme.chip}`}
        >
          <i className="ri-chat-thread-line" />
          {topic.boardName}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/topic/${topic.id}`} className="transition-colors hover:text-primary-700">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {topic.excerpt}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {topic.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
            >
              #{tag}
            </span>
          ))}
        </div>
        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-medium text-secondary-800">
              {topic.author.slice(0, 1)}
            </span>
            <span className="max-w-[7rem] truncate">{topic.author}</span>
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-chat-smile-2-line" />
              {topic.replies}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {topic.views}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}